import HiddenAudioPlayer from './HiddenAudioPlayer';

export default HiddenAudioPlayer;
